import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../contact-us/contact-us.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import Swal from 'sweetalert2';

@Component ({
    selector: 'app-home-en',
    templateUrl: './home-en.component.html',
    styleUrls: ['./home-en.component.scss'],
    standalone: false
})
export class HomeEnComponent implements OnInit {
  play = true;
  updateForm: UntypedFormGroup;
  submitted: boolean;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    items: 1,
    pullDrag: false,
    autoplay: true,
    autoplayTimeout: 3500,
    autoplaySpeed: 1000,
    dots: true,
    navSpeed: 700,
    navText: ['Previous', 'Next'],
    nav: false
  };
  slidesStore = [
    {
      src: '../../assets/images/bg-1.png',
      id: '1'
    },
    {
      src: '../../assets/images/bg.png',
      id: '2'
    },
    {
      src: '../../assets/images/bg-3.png',
      id: '3'
    },
  ];
  videOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    items: 1,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    center: true,
    startPosition: 1,
    navText: ['Previous', 'Next'],
    nav: true
  };

  constructor(
      private builder: UntypedFormBuilder,
      private contactService: ContactUsService) {
  }

  ngOnInit(): void {
    this.initForm ();
  }

  initForm(): void {
    this.updateForm = this.builder.group (
        {
          phone: ['', Validators.required],
          name: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          notes: ['', [Validators.required, Validators.minLength (20)]]
        },
        onblur
    );
  }

  isFieldValid(field: string): boolean {
    return (
        !this.updateForm.get (field).valid && this.updateForm.get (field).touched
    );
  }

  onSubmit(): void {
    if ( this.updateForm.valid ) {
      this.submitted = true;
      const popup = {
        title: 'Your inquiry has been sent successfully',
        text: 'We will contact you as soon as possible',
        button: 'Done',
      };

      this.contactService.sendMail (this.updateForm.value).subscribe (
          (res) => {
            Swal.fire ({
              title: popup.title,
              text: popup.text,
              icon: 'success',
              confirmButtonText: popup.button,
            }).then (() => {
              this.submitted = false;
              this.updateForm.reset ();
            });
          },
          (err) => {
            console.log (err);
            this.submitted = false;
          }
      );
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView ({behavior: 'smooth'});
  }

  // tslint:disable-next-line:typedef
  playPause() {
    const video = document.querySelector ('#video') as HTMLVideoElement;
    this.play = !this.play;

    if ( video.paused ) {
      video.play ();
    } else {
      video.pause ();
    }
  }

  // tslint:disable-next-line:typedef
  playPause2() {
    const video = document.querySelector ('#video2') as HTMLVideoElement;
    this.play = !this.play;

    if ( video.paused ) {
      video.play ();
    } else {
      video.pause ();
    }
  }


  // tslint:disable-next-line:typedef
  viewSlider(id) {
    const pro = document.querySelector ('#projectttt');
    if ( id == 1 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project1').classList.add ('active');

      pro.innerHTML = `
      <img src='../../assets/images/lv1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/lv2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/lv3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/lv4.png' class='img-fluid m-2' alt=''>
     `;
    }
    if ( id == 2 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project2').classList.add ('active');
      pro.innerHTML = `
      <img src='../../assets/images/mv1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/mv2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/mv3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/mv4.png' class='img-fluid m-2' alt=''>
     `;
    }
    if ( id == 3 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project3').classList.add ('active');
      pro.innerHTML = `
      <img src='../../assets/images/sv1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/sv2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/sv3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/sv4.png' class='img-fluid m-2' alt=''>
     `;
    }
    if ( id == 4 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project4').classList.add ('active');
      pro.innerHTML = `
      <img src='../../assets/images/xv1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/xv2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/xv3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/xv4.png' class='img-fluid m-2' alt=''>
     `;
    }
    if ( id == 5 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project5').classList.add ('active');
      pro.innerHTML = `
      <img src='../../assets/images/twinhouse1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/twinhouse2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/twinhouse3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/twinhouse4.png' class='img-fluid m-2' alt=''>
     `;
    }
    if ( id == 6 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project6').classList.add ('active');
      pro.innerHTML = `
      <img src='../../assets/images/townhouse1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/townhouse2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/townhouse3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/townhouse4.png' class='img-fluid m-2' alt=''>
     `;
    }
    if ( id == 7 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project7').classList.add ('active');
      pro.innerHTML = `
      <img src='../../assets/images/tr1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/tr2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/tr3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/tr4.png' class='img-fluid m-2' alt=''>
     `;
    }
    if ( id == 8 ) {
      const projects = document.querySelectorAll ('[id*="project"]').forEach ((res) => {
        res.classList.remove ('active');
      });
      const proo = document.querySelector ('#project7').classList.add ('active');
      pro.innerHTML = `
      <img src='../../assets/images/tr1.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/tr2.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/tr3.png' class='img-fluid m-2' alt=''>
      <img src='../../assets/images/tr4.png' class='img-fluid m-2' alt=''>
     `;
    }
  }
}
